<template>
<div>

	<v-menu
		bottom
		right
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				icon
				v-bind="attrs"
				v-on="on"
			>
				<v-icon>mdi-menu</v-icon>
			</v-btn>
		</template>
		<v-list nav dense>
			<v-list-item-group >
				<v-list-item  v-for="(item, i) in items" :key="i" :to="item.route_path">
					<v-list-item-icon>
						<v-icon>mdi-{{ item.icon }}</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ item.title }}</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="isLogged" @click="doLogout()">
					<v-list-item-icon>
						<v-icon>mdi-logout</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Esci</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
				
				<v-list-item v-if="!isLogged"  @click="openLoginDialog()">
					<v-list-item-icon>
						<v-icon>mdi-login</v-icon>
					</v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>Accedi</v-list-item-title>
					</v-list-item-content>
				</v-list-item>
			</v-list-item-group>
		</v-list>
	</v-menu>

	<v-dialog
    v-model="loginDialog"
    max-width="300px"
  >
    <v-card>
      <v-card-title>
        <!-- <span>Accedi</span> -->
        <v-progress-linear v-if="isLoading" class="mt-2 mb-2" :indeterminate="true"></v-progress-linear>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-text-field
              label="Username *"
              v-model="username"
              outlined
              dense
              required
            ></v-text-field>
            <!-- :rules="[vincoli.required]" -->
            <v-text-field
              label="Password *"
              v-model="password"
              outlined
              dense
              name="password"
              :type="togglePassword ? 'password' : 'text'"
              :append-icon="togglePassword ? 'mdi-eye' : 'mdi-eye-off'"
              @click:append="() => (togglePassword = !togglePassword)"
              required
            ></v-text-field>
            <v-alert 
              :value="showAlert"
              class="mb-1"
              transition="scale-transition"
              dense
              type="error"
              width="100%"
              text
            >
              {{ alertMessage }}
            </v-alert>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          @click="doLogin()"
          class="mb-2"
        >
          Accedi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import mixin from '../mixin';
import store from '../store';
export default {
  mixins: [mixin],
  data() {
    return {
      showAlert: false,
      alertMessage: null,

      selectedMenuItem: null,

      isLoading: false,
      loginDialog: false,
      username: null,
      password: null,
      togglePassword: true
    };
  },

  computed: {
    items() {
      let items = [
        {
          icon: 'file-certificate',
          title: 'Tecnici',
          route_path: '/tecnici'
        }
      ];

      if (this.isLogged) {
        items.push(
          {
            icon: 'school',
            title: 'Corsi',
            route_path: '/corsi'
          },
          // {
          //   icon: 'chart-areaspline',
          //   title: 'Statistiche',
          //   route_path: '/statistiche'
          // },
        )
      }

      return items;
    }
  },

  watch: {
    
  },

  mounted() {
    
  },

  created() {
  },

  methods: {
    // doLogin: function() {
		// 	this.alertType = null;
		// 	this.message = null;
		// 	this.isLoading = true;

		// 	axios.post("/login", {
    //     username: this.username,
    //     password: this.password
    //   })
    //   .then(res => {
    //     if (res.data.result == "success") {
    //       store.commit('setIsLogged', true);
    //       this.loginDialog = false;
    //       this.username = null;
    //       this.password = null;
    //     }
    //     else {
    //       this.showAlert = true;
		// 			setTimeout(() => {
		// 				this.showAlert = false
		// 			},5000)
    //       this.alertMessage = res.data.message;
    //     }
    //   })
    //   .catch(err => {
    //     this.showAlert = true;
    //     setTimeout(() => {
    //       this.showAlert = false
    //     },5000)
    //     this.alertMessage = "Autenticazione fallita";
    //   })
    //   .finally(() => {
    //     this.isLoading = false;
    //   });
		// },
    doLogout() {
      axios.get('/logout')
      .then(res => {
        this.$router.push({ name: 'tecnici'})
        store.commit('setIsLogged', false);
      })
      // .then(() => {
      //   // window.location.href = "/";
      //   this.$router.push({ name: 'tecnici'})
      // })
      // this.selectedMenuItem = null;
    },
    openLoginDialog() {
      this.loginDialog = true;
      // this.selectedMenuItem = null;
    }
  },
};
</script>